/*
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
*/

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import vuetify from './plugins/vuetify'
import { Auth } from './models/Auth';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import 'ol-layerswitcher/src/ol-layerswitcher.css'

import Civil from './Civil.vue'
import resetPassword from './resetPassword.vue'
import SurveyorDownload from './SurveyorDownload.vue'

require('./bootstrap');

window.Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('civil', require('./Civil.vue').default);
Vue.component('resetPassword', require('./resetPassword.vue').default);
Vue.component('SurveyorDownload', require('./SurveyorDownload.vue').default);


Vue.use(Auth);

import language from './lang/lang.js';
import Projections from './models/Projections';
import Tasks from './models/Tasks';
import Projects from './models/Projects';
const language_plugin = {
  install() {
    Vue.language = language;
    Vue.prototype.language = language;
  }
}
Vue.use(language_plugin);

var projections = Vue.observable(new Projections());
projections.setProjections([
  {
    "projectionId": 1,
    "code": "EPSG:28992",
    "name": "RD (NSGI RDNAP 2008)",
    "def": "+proj=sterea +lat_0=52.15616055555555 +lon_0=5.38763888888889 +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +towgs84=565.417,50.3319,465.552,-0.398957,0.343988,-1.8774,4.0725 +units=m +no_defs"
  }
]);


var tasks = Vue.observable(new Tasks())
var projects = new Projects()
var selectedVector = Vue.observable({ accountId: 0 })
var selectedTask = Vue.observable({ taskId: 0 })
var selectedUnitSystem = "me" // "me" || "im"
var cancelSource = null;
var units = Vue.observable(new Units());


var globaldata = {
  install() {
    Object.defineProperty(Vue.prototype, '$projections', {
      get() { return projections; }
    });
    Object.defineProperty(Vue.prototype, '$tasks', {
      get() { return tasks; }
    });
    Object.defineProperty(Vue.prototype, '$projects', {
      get() { return projects; }
    });
    Object.defineProperty(Vue.prototype, '$selectedVector', {
      get() { return selectedVector; }, set(newValue) { selectedVector.accountId = newValue; }
    });
    Object.defineProperty(Vue.prototype, '$selectedTask', {
      get() { return selectedTask; }, set(newValue) { selectedTask.taskId = newValue; }
    });
    Object.defineProperty(Vue.prototype, '$selectedUnitSystem', {
      get() { return selectedUnitSystem; }, set(newValue) { selectedUnitSystem = newValue; }
    });
    Object.defineProperty(Vue.prototype, '$units', {
      get() { return units; }
    });
    Object.defineProperty(Vue.prototype, '$cancelSource', {
      get() { return cancelSource; }, set(newValue) { cancelSource = newValue; }
    });
  }
}
Vue.use(globaldata);

Vue.prototype.$axios = axios;
Vue.prototype.$axios.defaults.withCredentials = true
// general interceptor to catch 401(Unauthorized)
Vue.prototype.$axios.interceptors.response.use((response) => {
  return response
}, (error) => {
  if (error.response && error.response.status == 401) {
    console.log("showLogin");
    Vue.prototype.$auth.showLogin();
    return new Promise(() => { });
  }
  return Promise.reject(error);
})

cancelSource = Vue.prototype.$axios.CancelToken.source();
Vue.prototype.$axios.interceptors.request.use((config) => {
  config.CancelToken = cancelSource.token;
  return config;
})


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import { getCookie, setCookie } from './models/Cookies.js';
import Units from './models/Units.js';

if (document.getElementById('app')) {
  const app = new Vue({
    vuetify,
    render: h => h(Civil),
    created() {
      let x = getCookie('language');
      if (x) this.language.locale = x

      let u = getCookie('selectedUnitSystem');
      if (u) {
        this.$selectedUnitSystem = u
      }
      // else {
      //   setCookie('units', "me", 365);
      //   this.$selectedUnitSystem = "me"
      // }

      this.$auth.check()
    },
  }).$mount('#app')
}

if (document.getElementById('resetPassword')) {
  const passwordReset = new Vue({
    vuetify,
    render: h => h(resetPassword),

  }).$mount('#resetPassword')
}

if (document.getElementById('surveyorDownload')) {
  const surveyorDownload = new Vue({
    vuetify,
    render: h => h(SurveyorDownload),

  }).$mount('#surveyorDownload')
}


